import { createRouter, createWebHashHistory } from "vue-router";
import canvas from "../views/AiCanvas/index";
import chat from "../views/AiChat/index";
import store from "@/store";
const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/chat",
  },
  {
    path: "/canvas",
    name: "canvas",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: canvas,
  },
  {
    path: "/square",
    name: "square",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "square" */ "../views/Square/index"),
  },
  {
    path: "/collect",
    name: "collect",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "collect" */ "../views/Collect/index.vue"),
  },
  {
    path: "/test",
    name: "test",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "test" */ "../views/index.vue"),
  },
  {
    path: "/chat",
    name: "chat",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: chat,
  },
  {
    path: "/invite",
    name: "invite",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "collect" */ "../views/Invite/index.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory("/aidraw/"),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name !== "chat") store.commit("SET_CHAT_SLIDER", false);
  next();
});

export default router;
